/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LlgPolicy } from '../models/LlgPolicy';

export class GetLlgPolicyResponse {
  'llgPolicy': LlgPolicy | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "llgPolicy",
      "baseName": "llgPolicy",
      "type": "LlgPolicy",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetLlgPolicyResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

